import VendorsHeader from '../components/DataTable/StatisticsVendorsHeader';
import SoldCell from '../components/DataTable/StatisticsSalesSoldCell';
import ExpandCell from '../components/DataTable/ExpandCell';
import MultiLineHeader from '../components/DataTable/MultiLineHeader';

const DATA_TITLE = 'data-title';
const { currency } = document.getElementById('root').dataset || {};

function getCellClassName(cellName) {
    return 'statsVendors__cell statsVendors__bodyCell '
        + `statsVendors__cell_${cellName} statsVendors__bodyCell_${cellName}`;
}

function getHeadCellClassName(cellName) {
    return 'ui-table__cell statsVendors__cell statsVendors__headCell '
        + `statsVendors__cell_${cellName} statsVendors__headCell_${cellName}`;
}

/**
 * Config for statistics vendors table
 */
export default {
    headerComponent: VendorsHeader,
    columns: [
        {
            headerClassName: getHeadCellClassName('expand'),
            className: getCellClassName('expand'),
            columnName: '_spacer',
            displayName: '',
            headerDataAttrs: {
                [DATA_TITLE]: 'expand'
            },
            customCell: ExpandCell
        },
        {
            headerClassName: getHeadCellClassName('vendor'),
            className: getCellClassName('vendor'),
            columnName: 'seller_name',
            displayName: 'Vendor',
            headerDataAttrs: {
                [DATA_TITLE]: 'vendor'
            },
        },
        {
            headerClassName: getHeadCellClassName('lotsCatd'),
            className: getCellClassName('lotsCatd'),
            columnName: 'total_count',
            customHeader: {
                component: MultiLineHeader,
                options: {
                    displayName: [
                        {
                            text: 'Lots'
                        },
                        {
                            text: 'CATD'
                        }
                    ]
                }
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'catd'
            }
        },
        {
            headerClassName: getHeadCellClassName('lotsOffd'),
            className: getCellClassName('lotsOffd'),
            columnName: 'offered_count',
            customHeader: {
                component: MultiLineHeader,
                options: {
                    displayName: [
                        {
                            text: 'Lots'
                        },
                        {
                            text: 'OFFD'
                        }
                    ]
                }
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'offd'
            }
        },
        {
            headerClassName: getHeadCellClassName('lotsSold'),
            className: getCellClassName('lotsSold'),
            columnName: 'sold_percent',
            customHeader: {
                component: MultiLineHeader,
                options: {
                    displayName: [
                        {
                            text: 'Lots'
                        },
                        {
                            text: 'SOLD (%)'
                        }
                    ]
                }
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'sold_percent'
            },
            customCell: {
                component: SoldCell,
                options: {
                    columnSold: 'sales_count',
                    columnPercentage: 'sold_percent',
                }
            }
        },
        {
            headerClassName: getHeadCellClassName('aggregate'),
            className: getCellClassName('aggregate'),
            columnName: 'price_total',
            displayName: `Aggregate ${currency ? `(${currency})` : ''}`,
            headerDataAttrs: {
                [DATA_TITLE]: 'aggregate_sales'
            }
        },
        {
            headerClassName: getHeadCellClassName('priceAverage'),
            className: getCellClassName('priceAverage'),
            columnName: 'price_average',
            customHeader: {
                component: MultiLineHeader,
                options: {
                    displayName: [
                        {
                            text: ` Price${currency ? ` (${currency})` : ''}`
                        },
                        {
                            text: 'Avg.'
                        }
                    ]
                }
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'average'
            }
        },
        {
            headerClassName: getHeadCellClassName('priceHigh'),
            className: getCellClassName('priceHigh'),
            columnName: 'price_max',
            customHeader: {
                component: MultiLineHeader,
                options: {
                    displayName: [
                        {
                            text: ` Price${currency ? ` (${currency})` : ''}`
                        },
                        {
                            text: 'High'
                        }
                    ]
                }
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'high'
            }
        },
        {
            headerClassName: getHeadCellClassName('priceMedian'),
            className: getCellClassName('priceMedian'),
            columnName: 'median',
            customHeader: {
                component: MultiLineHeader,
                options: {
                    displayName: [
                        {
                            text: ` Price${currency ? ` (${currency})` : ''}`
                        },
                        {
                            text: 'Median'
                        }
                    ]
                }
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'median'
            }
        },
        {
            headerClassName: getHeadCellClassName('priceLow'),
            className: getCellClassName('priceLow'),
            columnName: 'price_min',
            customHeader: {
                component: MultiLineHeader,
                options: {
                    displayName: [
                        {
                            text: ` Price${currency ? ` (${currency})` : ''}`
                        },
                        {
                            text: 'Low'
                        }
                    ]
                }
            },
            headerDataAttrs: {
                [DATA_TITLE]: 'low'
            }
        }
    ]
};



// WEBPACK FOOTER //
// ./src/js/config/statisticsVendorsTable.js